/**
 * TanStack Query hooks for `partnerstack-integration-via-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	partnerstackIntegrationViaApiQueryKeys,
	type CreatePartnerstackIntegrationViaApiBody,
	type ListPartnerstackIntegrationViaApiResponse,
	type PartnerstackIntegrationViaApiRow,
} from "./api";

export function usePartnerstackIntegrationViaApiList(): UseQueryResult<ListPartnerstackIntegrationViaApiResponse, Error> {
	return useQuery({
		queryKey: partnerstackIntegrationViaApiQueryKeys.list(),
		queryFn: list,
	});
}

export function usePartnerstackIntegrationViaApiCreate(): UseMutationResult<PartnerstackIntegrationViaApiRow, Error, CreatePartnerstackIntegrationViaApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: partnerstackIntegrationViaApiQueryKeys.all });
		},
	});
}

export function usePartnerstackIntegrationViaApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: partnerstackIntegrationViaApiQueryKeys.all });
		},
	});
}
